import api from './api';

const reviewService = {
  // Récupérer les avis d'une boutique
  getBoutiqueReviews: async (boutiqueId, params = {}) => {
    try {
      const response = await api.get(`/reviews/boutique/${boutiqueId}`, { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des avis:', error);
      throw error;
    }
  },

  // Créer un avis pour une boutique
  createBoutiqueReview: async (boutiqueId, reviewData) => {
    try {
      const response = await api.post(`/reviews/boutique/${boutiqueId}`, reviewData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de l\'avis:', error);
      throw error;
    }
  },

  // Mettre à jour un avis
  updateReview: async (reviewId, reviewData) => {
    try {
      const response = await api.put(`/reviews/${reviewId}`, reviewData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de l\'avis:', error);
      throw error;
    }
  },

  // Supprimer un avis
  deleteReview: async (reviewId) => {
    try {
      const response = await api.delete(`/reviews/${reviewId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'avis:', error);
      throw error;
    }
  },

  // Récupérer la note moyenne d'une boutique
  getBoutiqueRating: async (boutiqueId) => {
    try {
      const response = await api.get(`/reviews/boutique/${boutiqueId}/rating`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de la note:', error);
      throw error;
    }
  },

  // ========== MÉTHODES POUR LES AVIS DE PRODUITS ==========

  // Récupérer les avis d'un produit
  getProductReviews: async (productId, params = {}) => {
    try {
      const response = await api.get(`/reviews/product/${productId}`, { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des avis:', error);
      throw error;
    }
  },

  // Créer un avis pour un produit
  createProductReview: async (productId, reviewData) => {
    try {
      const response = await api.post(`/reviews/product/${productId}`, reviewData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de l\'avis:', error);
      throw error;
    }
  },

  // Récupérer la note moyenne d'un produit
  getProductRating: async (productId) => {
    try {
      const response = await api.get(`/reviews/product/${productId}/rating`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de la note:', error);
      throw error;
    }
  }
};

export default reviewService;

